export class UUID {
  private _value: string;
  private _separator: string = '-';

  constructor(separator?: string) {
    this._separator = typeof(separator) !== 'undefined' ? separator : this._separator;

    this._value = this.generate();
  }

  private pad4(num): string {
    let ret = num.toString(16);
    while (ret.length < 4) {
      ret = '0' + ret;
    }
    return ret;
  }

  private random4(): string {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  private generate(): string {
    if (
      typeof (window) !== 'undefined' &&
      typeof (window.crypto) !== 'undefined' &&
      typeof (window.crypto.getRandomValues) !== 'undefined'
    ) {
      // If we have a cryptographically secure PRNG, use that
      // http://stackoverflow.com/questions/6906916/collisions-when-generating-uuids-in-javascript
      const buf = new Uint16Array(8);
      window.crypto.getRandomValues(buf);

      return (
        this.pad4(buf[0]) +
        this.pad4(buf[1]) +
        this._separator +
        this.pad4(buf[2]) +
        this._separator +
        this.pad4(buf[3]) +
        this._separator +
        this.pad4(buf[4]) +
        this._separator +
        this.pad4(buf[5]) +
        this.pad4(buf[6]) +
        this.pad4(buf[7]));
    } else {
      // Otherwise, just use Math.random
      // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
      return this.random4() +
        this.random4() +
        this._separator +
        this.random4() +
        this._separator +
        this.random4() +
        this._separator +
        this.random4() +
        this._separator +
        this.random4() +
        this.random4() +
        this.random4();
    }
  }

  public toString(): string {
    return this._value;
  }
}



// WEBPACK FOOTER //
// ./src/app/global/uuid.entity.ts